import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'

type VideoSessionState = {
  /**
   * The appointment the open video session was joined from. Stored whole (not just the id) so that
   * everything deciding what renders around the session — ProviderSession and the layout hooks that
   * reserve space for its banners — reads the same appointment instead of looking it up again.
   */
  videoSessionAppointment: Appointment | null
  privacyGuardOn: boolean
  informedConsentBannerHeight: number | null
}

const initialState: VideoSessionState = {
  videoSessionAppointment: null,
  privacyGuardOn: false,
  informedConsentBannerHeight: null,
}

const videoSessionSlice = createSlice({
  name: 'videoSession',
  initialState,
  reducers: {
    setVideoSessionAppointment: (state, action: PayloadAction<Appointment | null>) => {
      state.videoSessionAppointment = action.payload
    },
    setPrivacyGuardOn: (state, action: PayloadAction<boolean>) => {
      state.privacyGuardOn = action.payload
    },
    setInformedConsentBannerHeight: (state, action: PayloadAction<number>) => {
      state.informedConsentBannerHeight = action.payload
    },
    clearVideoSession: (state) => {
      state.videoSessionAppointment = null
      state.privacyGuardOn = false
      state.informedConsentBannerHeight = null
    },
  },
})

export const { setVideoSessionAppointment, setPrivacyGuardOn, setInformedConsentBannerHeight, clearVideoSession } =
  videoSessionSlice.actions
export default videoSessionSlice.reducer
